import React, { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";

import Progress from "../Progress";

const AddGeneralFieldsTaskAction = ({
  items = [],
  onRequestParams,
  onComplete,
  render,
  //
  chatHelpersStore,
  component
}) => {

  const [progress, setProgress] = useState({label: "Creating fields"})
  
  const handleComplete = async (...params) => {
    typeof onComplete === "function" && (await onComplete(...params));
  };

  const handleOnLoad = async () => {
    try {
      const fieldBySheetId = {};

      const finalItems =
        (typeof onRequestParams === "function" && (await onRequestParams())) ||
        items;

      // group all formulae by target sheetId
      for (const fields of finalItems) {
        let sheetId = fields.sheetId;
        if (!fieldBySheetId.hasOwnProperty(sheetId))
          fieldBySheetId[fields.sheetId] = fields
        else
          fieldBySheetId[fields.sheetId]?.fields?.push(...fields.fields);
      }

      const addFieldsPromises = Object.keys(fieldBySheetId).map((sheetId) => {
        const { fields, parentSheetId, sheetName } = fieldBySheetId[sheetId];
        return chatHelpersStore.addFieldsToSheetApiHelper({
          fields,
          sheetId,
          sheetName,
          parentSheetId,
        });
      });

      const createdFieldsPerSheet = (
        await Promise.allSettled(addFieldsPromises)
      )
        .filter((item) => item.reason !== "rejected" && item.value)
        .map((item) => {
          // forward parent sheet name, since not being passed.
          const { parentSheetName } = fieldBySheetId[item.value?.sheetId] || {};
          return { ...item.value, parentSheetName };
        });

      await handleComplete(createdFieldsPerSheet);
    } catch (e) {
      console.log(`e->`, e);
    }
  };

  const renderAddGeneralFieldsTaskAction = () => {
    return <Progress progress={progress} parentComponent={component} />;
  };

  useEffect(() => {
    handleOnLoad();
  }, []);

  return renderAddGeneralFieldsTaskAction();
};

export default inject(({ store }) => {
  return {
    assistantStore: store.assistantStore,
    chatHelpersStore: store.chatHelpersStore,
  };
})(observer(AddGeneralFieldsTaskAction));
